import { QrcodeOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd"
import React from "react";
import { QRCode } from "react-qrcode-logo";

const QrCode = ({ sid,license, url }: {  license:string, sid?: string, url?: string }) => {
  const [showQr, setShowQr] = React.useState(false);
  const qcValue = url ? url : `{"type":"sid", "sid":"${sid}"}`;
  return <div>
    <Button icon={<QrcodeOutlined />} type="link" onClick={()=>{setShowQr(true)}}></Button>
    <Modal
      title={`二维码 ( ${license} )`}
      open={showQr}
      footer={null}
      onCancel={() => setShowQr(false)}
    >
      <div className="flex flex-center">
        <QRCode
          ecLevel="L"
          style={{ display: sid ? "block" : "none" }}
          size={300}
          fgColor="#1890ff"
          value={qcValue}
        />
      </div>
    </Modal>

  </div>
}

export default QrCode